/*
 * @Description: 首页
 * @Author: gao shuai
 * @Date: 2020-05-11 16:53:43
 * @LastEditTime: 2020-08-18 14:15:35
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 充值信息
  async chargeInfo(params) {
    return api({ url: '/api/HomePage/GetHomePageOrdersTodayListAsync', method: 'get', params });
  },
  // 获取公告信息
  async getNotice(params) {
    return api({ url: '/api/HomePage/GetNoticeListAsync', method: 'get', params });
  },
  // 获取用户信息
  async getUserinfo(params) {
    return api({ url: '/api/HomePage/GetMerchantsInformationListAsync', method: 'get', params });
  },
  // 获取账户余额
  async getAccountInfo(params) {
    return api({ url: '/api/HomePage/GetHomePageBanksListAsync', method: 'get', params });
  },
  // 提现金额，提现手续费
  async cashWithdraw(params) {
    return api({ url: '/api/HomePage/GetHomeCashWithdrawalACListAsync', method: 'get', params });
  },
  // 获取最新充值订单列表
  async orderList(params) {
    return api({ url: '/api/HomePage/GetNewestOrdersListAsync', method: 'get', params });
  },
  // 在线客户显示
  async serviceShow(params) {
    return api({ url: '/api/HomePage/GetServiceStateListAsync', method: 'get', params });
  },
  // 获取玩家留言数量
  async leaveMessage(params) {
    return api({ url: '/api/HomePage/GetGamePlayerMessageCountAsync', method: 'get', params });
  },
  // 在线客服off/on
  async serviceOff(params) {
    return api({ url: '/api/HomePage/GetOnlineCustomerServiceStateUpdateAsync', method: 'post', data: params });
  },
  // 玩家留言off/on
  async leaveMessageOff(params) {
    return api({ url: '/api/HomePage/OnlineLeaveStateOffUpdateAsync', method: 'post', data: params });
  },
  // 手机号码off/on
  async phoneOff(params) {
    return api({ url: '/api/HomePage/OnlinePhoneStateOffUpdateAsync', method: 'post', data: params });
  },
  // 结算比率列表
  async rankList(params) {
  return api({ url: '/api/HomePage/GetRanksListAsync', method: 'get', params });
  },
  // 结算比率状态改变
  async rankState(params) {
  return api({ url: '/api/HomePage/ChangeRanksOffOnAsync', method: 'post', data: params });
  },
  // 重置密码
  async resetPassword(params) {
  return api({ url: '/api/UserManage/ResetPassword', method: 'post', data: params });
  },
  // 检测个人信息
  async checkPersonInfo(params) {
  return api({ url: '/api/HomePage/CheckTenantInformationAsync', method: 'get', params });
  },
  /* ---------------------2.留言箱-------------------- */
  // 留言箱list
  async messageList(params) {
  return api({ url: '/api/HomePage/GetGamePlayerMessageListAsync', method: 'get', params });
  },
  // 更改留言箱的未读状态
  async mailState(params) {
  return api({ url: '/api/HomePage/ChangeMessageStateAsync', method: 'post', data: params });
  },
  // 删除邮箱信息
  async delMail(params) {
  return api({ url: '/api/HomePage/DeleteMerchantMessageAsync', method: 'post', data: params });
  },
  // 提现信息
  async withdrawApply(params) {
  return api({ url: '/api/HomePage/CashWithdrawalListAsync', method: 'get', params });
  },
  // 提现提交
  async withdrawSumbit(params) {
  return api({ url: '/api/HomePage/CashWithdrawalOperationAsync', method: 'post', data: params });
  },
  // 退出时调用接口
  async loginOut(params) {
  return api({ url: '/api/HomePage/LoginOutAsync', method: 'post', data: params });
  },
  // 上传图像的图片
  async uploadprofit(params) {
  return api({ url: '/api/HomePage/UploadImage', method: 'post', data: params });
  },
  // 获取用户图像
  async getProfile(params) {
  return api({ url: '/api/HomePage/GetHeadImgAsync', method: 'get', params });
  },
  // 获取充值的默认值
  async rechargeDefault(params) {
  return api({ url: '/api/UserCenter/GetDefaultRechargeAmount', method: 'get', params });
  },
  // 设置商户充值金额
  async rechargeSetting(params) {
  return api({ url: '/api/UserCenter/SetRechargeAmount', method: 'post', data: params });
  },
  // 代理获取注册推广链接
  async promateLink(params) {
  return api({ url: '/api/HomePage/GetPopularizationUrl', method: 'get', params });
  },
  // 单个订单下发
  async waitSent(params) {
  return api({ url: '/api/OrderIssue/SendSingleOrder', method: 'get', params });
  },
  // 单个订单下发
  async waitSentAll(params) {
  return api({ url: '/api/OrderIssue/BatchSendOrder', method: 'get', params });
  },
  // 设置皮肤
  async setSkin(params) {
  return api({ url: '/api/HomePage/SetDefaultSkinAsync', method: 'post', data: params });
  },
  // 下载网关
  async downloadNet(params) {
  return api({ url: '/api/UserCenter/GetFileAsync', method: 'get', params });
  }
};
